export const QA_NAME_USER_MENU = 'userMenu'
